/**
 * Stacking order contains z-index values that are used through.
 * Note that the Stack component might increase the z-index for certain components.
 */
export default {
  /**
   * Used for focused buttons and controls.
   */
  FOCUSED: 2,

  /**
   * Used as the default for the StackingContext.
   */
  STACKING_CONTEXT: 5,

  /**
   * Used as the default for the Positioner.
   */
  POSITIONER: 10,

  /**
   * Used for the Overlay and everything that's inside such as Dialog + SideSheet.
   */
  OVERLAY: 20,

  /**
   * Used for the toasts in the toaster. Appears on top of everything else.
   */
  TOASTER: 30
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb25zdGFudHMvc3JjL1N0YWNraW5nT3JkZXIuanMiXSwibmFtZXMiOlsiRk9DVVNFRCIsIlNUQUNLSU5HX0NPTlRFWFQiLCJQT1NJVElPTkVSIiwiT1ZFUkxBWSIsIlRPQVNURVIiXSwibWFwcGluZ3MiOiJBQUFBOzs7O0FBSUEsZUFBZTtBQUNiOzs7QUFHQUEsV0FBUyxDQUpJOztBQU1iOzs7QUFHQUMsb0JBQWtCLENBVEw7O0FBV2I7OztBQUdBQyxjQUFZLEVBZEM7O0FBZ0JiOzs7QUFHQUMsV0FBUyxFQW5CSTs7QUFxQmI7OztBQUdBQyxXQUFTO0FBeEJJLENBQWYiLCJmaWxlIjoiU3RhY2tpbmdPcmRlci5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8qKlxuICogU3RhY2tpbmcgb3JkZXIgY29udGFpbnMgei1pbmRleCB2YWx1ZXMgdGhhdCBhcmUgdXNlZCB0aHJvdWdoLlxuICogTm90ZSB0aGF0IHRoZSBTdGFjayBjb21wb25lbnQgbWlnaHQgaW5jcmVhc2UgdGhlIHotaW5kZXggZm9yIGNlcnRhaW4gY29tcG9uZW50cy5cbiAqL1xuZXhwb3J0IGRlZmF1bHQge1xuICAvKipcbiAgICogVXNlZCBmb3IgZm9jdXNlZCBidXR0b25zIGFuZCBjb250cm9scy5cbiAgICovXG4gIEZPQ1VTRUQ6IDIsXG5cbiAgLyoqXG4gICAqIFVzZWQgYXMgdGhlIGRlZmF1bHQgZm9yIHRoZSBTdGFja2luZ0NvbnRleHQuXG4gICAqL1xuICBTVEFDS0lOR19DT05URVhUOiA1LFxuXG4gIC8qKlxuICAgKiBVc2VkIGFzIHRoZSBkZWZhdWx0IGZvciB0aGUgUG9zaXRpb25lci5cbiAgICovXG4gIFBPU0lUSU9ORVI6IDEwLFxuXG4gIC8qKlxuICAgKiBVc2VkIGZvciB0aGUgT3ZlcmxheSBhbmQgZXZlcnl0aGluZyB0aGF0J3MgaW5zaWRlIHN1Y2ggYXMgRGlhbG9nICsgU2lkZVNoZWV0LlxuICAgKi9cbiAgT1ZFUkxBWTogMjAsXG5cbiAgLyoqXG4gICAqIFVzZWQgZm9yIHRoZSB0b2FzdHMgaW4gdGhlIHRvYXN0ZXIuIEFwcGVhcnMgb24gdG9wIG9mIGV2ZXJ5dGhpbmcgZWxzZS5cbiAgICovXG4gIFRPQVNURVI6IDMwXG59XG4iXX0=